import { position } from './chaos_pos';
import { position_nrw } from './chaos_pos_nrw';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Chaos {
  position: Array<any>;
  position_nrw: Array<any>;
  items: Array<any>;
  initialized: boolean;

  constructor() {
    this.position = position;
    this.position_nrw = position_nrw;
    this.items = [];
    this.initialized = false;
    this.init();
  }

  init() {
    this.factory();
    this.setScrollTrigger();
    this.eventBind();
    this.initialized = true;
  }

  setScrollTrigger() {
    let animated = false;

    ScrollTrigger.create({
      trigger: document.querySelector<HTMLElement>('.l-chaos'),
      start: '-20% 100%',
      //markers: true,
      onEnter: () => {
        if (!animated) {
          this.inAnimation();
          animated = true;
        }
      },
    });
  }

  inAnimation() {
    this.items.forEach((item, index) => {
      const dir = Math.random() > 0.5 ? 1 : -1;

      gsap.from(item, {
        top: '-30%',
        duration: 0.9,
        delay: index * 0.03,
        rotate: Math.random() * 45 * dir,
        ease: 'power4.in',
      });
    });
  }

  eventBind() {
    window.addEventListener('resize', () => {
      if (!this.initialized) return;

      this.items.forEach((item, index) => {
        this.setPosition(item, index);
      });
    });
  }

  setPosition(item: any, i: number) {
    if (window.innerWidth >= 768) {
      const ww = 1920;
      const wh = 800;
      item.style.top = (this.position[i].y / wh) * 100 + '%';
      item.style.left = (this.position[i].x / ww) * 100 + '%';
      item.style.width = (this.position[i].w / ww) * 100 + '%';
      item.style.opacity = '1'; //存在していれば表示

      if (this.position[i].d > 0) {
        //cssのrotateを使うとgsapと当たるのでtransformを使用する
        item.style.transform = `rotate(${-1 * this.position[i].d}deg)`;
      }
    } else {
      if (!this.position_nrw[i]) {
        item.style.opacity = 0;
        return;
      }

      const ww = 400;
      const wh = 400;
      item.style.top = (this.position_nrw[i].y / wh) * 100 + '%';
      item.style.left = (this.position_nrw[i].x / ww) * 100 + '%';
      item.style.width = (this.position_nrw[i].w / ww) * 100 + '%';
      item.style.opacity = '1'; //存在していれば表示

      if (this.position_nrw[i].d > 0) {
        //cssのrotateを使うとgsapと当たるのでtransformを使用する
        item.style.transform = `rotate(${-1 * this.position_nrw[i].d}deg)`;
      }
    }
  }

  factory() {
    const wrapper = document.querySelector<HTMLElement>('.l-chaos');
    const amount = 18;

    for (let i = 0; i < amount; i++) {
      const item = document.createElement('div');
      item.classList.add('l-chaos__item');
      this.setPosition(item, i);
      this.items.push(item);
      wrapper?.appendChild(item);
    }
  }
}
